document.documentElement.classList.remove('no-js');

class DrawerToggle extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', () => {
      this.toggleDrawer();
    });
    this.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      this.toggleDrawer();
    });
  }

  toggleDrawer() {
      const controls = this.getAttribute('aria-controls');
      const target = controls ? document.getElementById(controls) : null;
      if (!target) return;
      const open = target.hasAttribute('open');
      target.toggleAttribute('open', !open);
      this.setAttribute('aria-expanded', String(!open));
      document.documentElement.classList.toggle('drawer-open', !open);
  }
}

customElements.define('drawer-toggle', DrawerToggle);

document.addEventListener('click', (event) => {
  const close = event.target.closest('[data-drawer-close]');
  if (!close) return;
  const drawer = close.closest('[open]');
  if (drawer) drawer.removeAttribute('open');
  document.documentElement.classList.remove('drawer-open');
});

document.addEventListener('change', (event) => {
  const autoSubmit = event.target.closest('[data-auto-submit]');
  if (autoSubmit && autoSubmit.form) autoSubmit.form.submit();
});

document.addEventListener('toggle', (event) => {
  const group = event.target.closest('.mobile-nav__group');
  if (!group || !group.open) return;

  const nav = group.closest('.mobile-nav');
  if (!nav) return;

  nav.querySelectorAll('.mobile-nav__group[open]').forEach((item) => {
    if (item !== group) item.removeAttribute('open');
  });
}, true);

document.addEventListener('submit', (event) => {
  const form = event.target.closest('[data-product-card-form]');
  if (!form) return;
  event.preventDefault();

  const button = form.querySelector('.product-card__quick-add');
  if (button) button.classList.add('is-loading');

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Accept': 'application/json'
    },
    body: new FormData(form)
  })
    .then((response) => {
      if (!response.ok) throw new Error('cart add failed');
      form.classList.add('is-added');
      return fetch('/cart.js');
    })
    .then((response) => response.ok ? response.json() : null)
    .then((cart) => {
      if (!cart) return;
      document.querySelectorAll('.cart-link__count').forEach((count) => {
        count.textContent = cart.item_count;
      });
    })
    .catch(() => {
      form.submit();
    })
    .finally(() => {
      if (button) button.classList.remove('is-loading');
      window.setTimeout(() => form.classList.remove('is-added'), 1800);
    });
});

const siteHeader = document.querySelector('.site-header');
if (siteHeader) {
  const updateHeaderState = () => {
    siteHeader.classList.toggle('is-scrolled', window.scrollY > 8);
  };
  updateHeaderState();
  window.addEventListener('scroll', updateHeaderState, { passive: true });
}

const heroSliderTrack = document.querySelector('.hero-slider__track');
if (heroSliderTrack) {
  const slides = Array.from(heroSliderTrack.querySelectorAll('.hero-slide'));
  const dots = Array.from(document.querySelectorAll('.hero-slider__dots span'));
  let activeIndex = 0;
  let paused = false;
  let ticking = false;

  const setActiveDot = (index) => {
    dots.forEach((dot, dotIndex) => {
      dot.classList.toggle('is-active', dotIndex === index);
    });
  };

  const goToSlide = (index) => {
    if (!slides.length) return;
    activeIndex = (index + slides.length) % slides.length;
    heroSliderTrack.scrollTo({
      left: slides[activeIndex].offsetLeft,
      behavior: 'smooth'
    });
    setActiveDot(activeIndex);
  };

  heroSliderTrack.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(() => {
      const nextIndex = Math.round(heroSliderTrack.scrollLeft / heroSliderTrack.clientWidth);
      activeIndex = Math.max(0, Math.min(nextIndex, slides.length - 1));
      setActiveDot(activeIndex);
      ticking = false;
    });
  }, { passive: true });

  heroSliderTrack.addEventListener('pointerdown', () => {
    paused = true;
    heroSliderTrack.classList.add('is-dragging');
  });

  heroSliderTrack.addEventListener('pointerup', () => {
    paused = false;
    heroSliderTrack.classList.remove('is-dragging');
  });

  heroSliderTrack.addEventListener('pointercancel', () => {
    paused = false;
    heroSliderTrack.classList.remove('is-dragging');
  });

  dots.forEach((dot, index) => {
    dot.addEventListener('click', () => goToSlide(index));
  });

  if (slides.length > 1) {
    window.setInterval(() => {
      if (!paused && !document.hidden) goToSlide(activeIndex + 1);
    }, 5500);
  }
}

class ProductRecommendations extends HTMLElement {
  connectedCallback() {
    const url = this.dataset.url;
    if (!url) return;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(() => {});
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class VariantPicker extends HTMLElement {
  connectedCallback() {
    const variantsScript = this.querySelector('[data-variants]');
    if (!variantsScript) return;

    this.variants = JSON.parse(variantsScript.textContent);
    this.form = this.closest('form');
    this.productPage = this.closest('.product-page');
    this.addEventListener('change', () => this.onVariantChange());
  }

  onVariantChange() {
    const selectedOptions = Array.from(this.querySelectorAll('fieldset')).map((fieldset) => {
      const checked = fieldset.querySelector('input[type="radio"]:checked');
      return checked ? checked.value : null;
    });

    const variant = this.variants.find((item) => {
      return item.options.every((option, index) => option === selectedOptions[index]);
    });

    if (!variant) return;
    const idInputs = this.productPage
      ? this.productPage.querySelectorAll('form input[name="id"]')
      : this.form ? this.form.querySelectorAll('input[name="id"]') : [];
    idInputs.forEach((input) => {
      input.value = variant.id;
    });

    const submit = this.form.querySelector('[type="submit"]');
    if (!submit) return;
    submit.disabled = !variant.available;
  }
}

customElements.define('variant-picker', VariantPicker);
